/******************************************************************************
 * This file was generated by langium-cli 4.1.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/
import { PypestreamPifAstReflection } from './ast.js';
import { PypestreamPifGrammar } from './grammar.js';
export const PypestreamPifLanguageMetaData = {
    languageId: 'pypestream-pif',
    fileExtensions: ['.pif'],
    caseInsensitive: false,
    mode: 'development'
};
export const PypestreamPifGeneratedSharedModule = {
    AstReflection: () => new PypestreamPifAstReflection()
};
export const PypestreamPifGeneratedModule = {
    Grammar: () => PypestreamPifGrammar(),
    LanguageMetaData: () => PypestreamPifLanguageMetaData,
    parser: {}
};
//# sourceMappingURL=module.js.map